/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch(() => {
      dispatch(setLoading(false));
    });
};

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_ZERO_URA,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_ZERO_URA,
  isLoading: value,
});

// To get the defaut selection on the req screen when reopening the req screen
export const refreshZeroURA = () => ({
  type: ActionTypes.REFRESH_ZERO_URA,
  payload: {},
});
export const refreshZeroURADisplay = () => ({
  type: ActionTypes.REFRESH_ZERO_URA_DISPLAY,
  payload: {},
});
// Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_ZERO_URA,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// API call to get Max Quarter
export const getZeroURAMaxQtr = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.INVOICE_REGISTER_MAX_QUARTER}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MAX_QUARTER_ZERO_URA,
        zeroUraMaxQuarter: response.data.maxQuarterVO,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setZeroURAReport = (data) => ({
  type: ActionTypes.GET_ZERO_URA,
  searchResult: data,
});

// API call for the display screen grid for checked
export const getZeroURAResult = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.ZERO_URA}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.zeroUraReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(setZeroURAReport(response?.data?.zeroUraReportVO));
      }
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(setZeroURAReport([]));
      // return response;
    });
};
export const clearReduxZeroURASearchScreen = () => (dispatch) => {
  dispatch(dispatchPlanType([]));
  dispatch({
    type: ActionTypes.GET_MAX_QUARTER_ZERO_URA,
    zeroUraMaxQuarter: '',
  });
  dispatch(setLoading(false));
  dispatch(setSearchInput({ errors: [] }));
  dispatch(refreshZeroURA({}));
};
export const clearReduxZeroURADetailsScreen = () => (dispatch) => {
  dispatch(refreshZeroURADisplay({}));
  dispatch(setZeroURAReport([]));
};
